/* WCAG 2.1 AA markup fixes — axe audit 2026-09-16.
   Two defects that live outside editable theme markup:
     1. 1.1.1 Non-text Content: the <img> fallback Shopify renders inside <video>,
        and the app-injected Oddit trust-row badges, ship with no alt attribute.
     2. 4.1.2 Name, Role, Value: the header cart link carries
        aria-controls="cart-drawer" but UpCart replaced the native drawer, so the
        referenced id does not exist on the page.
   No MutationObserver on purpose: the theme already runs several body observers
   and they cost real CPU. Two passes (ready + settle) cover app-injected nodes. */
(function () {
  function fixImages() {
    // Video poster fallbacks are decorative: the <video> already carries aria-label.
    document.querySelectorAll('video > img:not([alt]), video-media img:not([alt])')
      .forEach(function (img) { img.setAttribute('alt', ''); });

    // Trust-row badges: use the sibling label text when there is one, else decorative.
    document.querySelectorAll('.oddit-trust-row img:not([alt])').forEach(function (img) {
      var label = (img.parentElement && img.parentElement.textContent || '').trim();
      img.setAttribute('alt', label ? label : '');
    });

    // Anything else left without alt gets an empty alt rather than a failing node.
    document.querySelectorAll('img:not([alt])').forEach(function (img) {
      img.setAttribute('alt', '');
    });
  }

  function fixDecorativeNumerals() {
    // The "01".."07" watermarks on listicle LPs sit at 0.18 opacity (1.19:1) and are
    // aria-hidden decoration. Darkening them to pass 1.4.3 would wreck the design, so
    // move the numeral into an attribute and let CSS ::before draw it: same pixels,
    // no text node, so it is decoration in markup as well as in intent.
    document.querySelectorAll('.listicle-7r__reason-number').forEach(function (el) {
      var t = (el.textContent || '').trim();
      if (t && !el.hasAttribute('data-num')) {
        el.setAttribute('data-num', t);
        el.textContent = '';
      }
    });
  }

  function fixAria() {
    document.querySelectorAll('[aria-controls]').forEach(function (el) {
      var id = el.getAttribute('aria-controls');
      if (id && !document.getElementById(id)) el.removeAttribute('aria-controls');
    });
  }

  function run() { try { fixImages(); fixDecorativeNumerals(); fixAria(); } catch (e) { /* never break the page */ } }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
  window.addEventListener('load', function () { setTimeout(run, 1200); }, { once: true });
})();
